class ProductPage extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.form);
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.addLabel = this.dataset.labelAdd;
    this.soldLabel = this.dataset.labelSold;
    this.initGallery();
    this.initOptions();
    this.initQty();
    this.initSticky();
    this.form.addEventListener('submit', (e) => this.submit(e));
  }

  initGallery() {
    const slides = this.querySelector('[data-slides]');
    const thumbs = [...this.querySelectorAll('[data-thumb]')];
    const items = [...slides.children];
    const counter = this.querySelector('[data-counter]');
    const sync = () => {
      const i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      if (counter) counter.textContent = items.length > 1 ? `${i + 1} / ${items.length}` : '';
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => slides.scrollTo({ left: items[k].offsetLeft - slides.offsetLeft, behavior: theme.reduce ? 'auto' : 'smooth' })));
    slides.addEventListener('scroll', sync, { passive: true });
    this.goToMedia = (id) => {
      const el = slides.querySelector(`[data-media="${id}"]`);
      if (el) slides.scrollTo({ left: el.offsetLeft - slides.offsetLeft, behavior: 'auto' });
    };
    sync();
  }

  initOptions() {
    this.form.addEventListener('change', (e) => {
      if (!e.target.matches('.pdp__opt input')) return;
      const chosen = [...this.form.querySelectorAll('.pdp__opt')].map((f) => f.querySelector('input:checked')?.value);
      const v = this.variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      this.setVariant(v);
    });
  }

  setVariant(v) {
    const ok = !!v && v.available;
    if (v) {
      this.form.querySelector('[data-variant-id]').value = v.id;
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      if (v.featured_media) this.goToMedia(v.featured_media.id);
      const was = v.compare_at_price > v.price ? `<s class="price__was">${theme.money(v.compare_at_price)}</s><span class="price__off">-${Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price)}%</span>` : '';
      this.querySelector('[data-price]').innerHTML = `<div class="price num"><span class="price__now">${theme.money(v.price)}</span>${was}</div>`;
      this.querySelector('[data-sticky-price]').textContent = theme.money(v.price);
    }
    const label = ok ? this.addLabel : this.soldLabel;
    this.querySelectorAll('[data-atc],[data-sticky-btn]').forEach((b) => (b.disabled = !ok));
    this.querySelectorAll('[data-atc-label],[data-atc-label-2]').forEach((s) => (s.textContent = v ? label : this.soldLabel));
    this.querySelector('[data-notify]').hidden = ok || !v ? !!ok : false;
  }

  initQty() {
    const input = this.querySelector('[data-qty-input]');
    this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qty));
    }));
  }

  initSticky() {
    const bar = this.querySelector('[data-sticky]');
    const target = this.querySelector('[data-atc-wrap]');
    new IntersectionObserver(([en]) => {
      const gone = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.hidden = !gone;
    }).observe(target);
  }

  async submit(e) {
    // "Buy it now" fallback button of the dynamic checkout posts the form to checkout natively
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    const err = this.querySelector('[data-error]');
    err.hidden = true;
    const btns = this.querySelectorAll('[data-atc],[data-sticky-btn]');
    btns.forEach((b) => b.setAttribute('aria-disabled', 'true'));
    try {
      const fd = new FormData(this.form);
      await theme.addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }]);
      theme.flyToCart([...this.querySelectorAll('.pdp__slide img')].find((i) => { const r = i.getBoundingClientRect(); return r.width && r.right > 0 && r.left < innerWidth; }) || e.submitter || this.querySelector('[data-atc]'));
      theme.toast(window.themeStrings.added, true);
    } catch (x) {
      err.textContent = x.message;
      err.hidden = false;
    } finally {
      btns.forEach((b) => b.removeAttribute('aria-disabled'));
    }
  }
}
customElements.define('product-page', ProductPage);
